// extracted by mini-css-extract-plugin
module.exports = {"buttons_container":"PromoBlockButtons_buttons_container__MsFhC","buttons_container_inner":"PromoBlockButtons_buttons_container_inner__YCtUT"};